<template>
  <v-data-table
    :headers="computedHeaders"
    :items="rows"
    item-key="key"
    :loading="loading"
    :no-data-text="$t('quotations.dates_view.none')"
    :footer-props="{ itemsPerPageOptions: [50, 100, -1] }"
    :items-per-page="100"
    :mobile-breakpoint="0"
    class="gradient-info__table"
    style="cursor: pointer"
    @click:row="row => $emit('open', row.offerId)"
  >
    <template v-slot:item.date="{ item }">
      <span class="text-no-wrap" :class="{ 'error--text font-weight-bold': isOverdue(item) }">{{ deadlineText(item.date, item.time) }}</span>
    </template>
    <template v-slot:item.title="{ item }">
      {{ item.title || $t('quotations.recipients.deadline') }}
    </template>
    <template v-slot:item.done="{ item }">
      <v-simple-checkbox v-if="item.dateIndex !== null" :value="false" :disabled="busy" :ripple="false" color="primary" @click.native.stop @input="$emit('done', item)" />
    </template>
  </v-data-table>
</template>

<script>
import { deadlinePassed, deadlineText } from '@/helpers/quotationDeadline';

// Tarjousten avoimet määräpäivät (jättöpäivät ja tärkeät päivät) päivämääräjärjestyksessä.
// Tärkeän päivän voi kuitata tehdyksi; jättöpäivä poistuu, kun tarjous merkitään lähetetyksi.
export default {
  name: 'QuotationDatesTable',
  props: {
    rows: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
  },
  data() {
    return {
      headers: [
        { text: this.$t('quotations.dates_view.date'), value: 'date', mobile: true },
        { text: this.$t('quotations.dates_view.what'), value: 'title', mobile: true },
        { text: this.$t('quotations.basics.card_project'), value: 'projectName', mobile: true },
        { text: this.$t('quotations.recipients.party'), value: 'partyName', mobile: false },
        { text: this.$t('quotations.author'), value: 'authorName', mobile: false },
        { text: this.$t('quotations.dates_view.done'), value: 'done', sortable: false, align: 'center', mobile: true },
      ],
    };
  },
  computed: {
    computedHeaders() {
      return this.$vuetify.breakpoint.xsOnly ? this.headers.filter(h => h.mobile) : this.headers;
    },
  },
  methods: {
    deadlineText,
    isOverdue(item) {
      return deadlinePassed(item.date, item.time);
    },
  },
};
</script>
